import {PopupDispatcher} from '../core/dispatchers'
import {IPopupDispatcher} from '../core/interfaces/dispatchers'
class AppPopupDispatcher extends PopupDispatcher {}

export const appPopupDispatcher = new AppPopupDispatcher() as IPopupDispatcher
